import { useRef } from "react";

import Card from "../ui/Card";
import classes from "./NewTaxrateForm.module.css";

export default function ChangeCostAndRevenueForm(props) {
    const nameInputRef = useRef();

    function submitHandler(event) {
        event.preventDefault();
        const enteredName = nameInputRef.current.value;
        const newData = {
            name: enteredName
        };
        props.onStoreChangedTaxrate(newData);
    }

    return <Card className={classes.card}>
        <form className={classes.card} onSubmit={submitHandler}>
            <div className={classes.card}>
                <label htmlFor='title'>New Name</label>
                <input type='text' required id='name' ref={nameInputRef} />
            </div>
            <div className={classes.card}>
                <button>Submit</button>
            </div>
        </form>
    </Card>
}